export const selectMfaDomain = () => (state) => state.mfa;
